import { render, staticRenderFns } from "./ShowBy.vue?vue&type=template&id=53c4a8c2&scoped=true"
import script from "./ShowBy.vue?vue&type=script&lang=js"
export * from "./ShowBy.vue?vue&type=script&lang=js"
import style0 from "./ShowBy.vue?vue&type=style&index=0&id=53c4a8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c4a8c2",
  null
  
)

export default component.exports